import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { ProjectInformation } from '@/app/api/morgan-thermal/project';

export const enableProject = createEndpoint<Informative>(({ fetch }) => {
  return (id: ProjectInformation['id']) => fetch(`/Project/Enable/${id}`, { method: 'POST' });
});